import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

import Swiper, {Navigation, Autoplay} from "swiper";
import 'swiper/css/bundle';

Swiper.use([Navigation, Autoplay]);
window.Swiper = Swiper;

Alpine.plugin(intersect)
Alpine.plugin(collapse)

Alpine.magic('nextFrame', () => callback => {
  requestAnimationFrame(() => requestAnimationFrame(callback))
})

window.Alpine = Alpine;

Alpine.start()
